import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { catchError, map, of, throwError } from 'rxjs';

import { ConfigService } from '@ph-core/services/config/config.service';
import { PrismicService } from '@ph-store/prismic/prismic.service';
import { validateHttpUrl } from '@ph-shared/utils/validate-http-url';

type RedirectUrl = { src: string; dest: string };

export const redirectGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);
  const prismicService = inject(PrismicService);
  const configService = inject(ConfigService);
  const environment = configService.environment;

  return prismicService.getPrismicData().pipe(
    map((data) =>
      data?.results?.length && data.results[0].data?.redirect_urls?.length
        ? data.results[0].data.redirect_urls
            .map((prismicRedirectUrl) => ({
              src: prismicRedirectUrl.slug?.[0]?.text,
              dest: prismicRedirectUrl.destination_uri?.url,
            }))
            .filter((redirect): redirect is RedirectUrl => Boolean(redirect.src && redirect.dest))
        : []
    ),
    catchError(() => of([] as RedirectUrl[])),
    map((prismicRedirectUrls) => {
      const redirectMatch = (prismicRedirectUrls || [])
        .concat(environment.redirectUrls)
        .find((elem) => elem.src === state.url);
      if (redirectMatch) {
        const safeDest = validateHttpUrl(redirectMatch.dest, { baseUrl: window.location.origin });
        if (safeDest) {
          window.location.href = safeDest;

          return true;
        }

        return router.parseUrl('/not-found');
      } else {
        return router.parseUrl('/not-found');
      }
    })
  );
};
